import { type AvailableLocals, getI18n, loadLocaleMessages, setI18nLanguage } from '@/plugins/i18n.ts'
import { setThemeCookie } from '@/utils/vuetify.ts'
import { useLocale } from 'vuetify/framework'

export function useAppLanguage () {
  const { current } = useLocale()

  async function updateLocale (locale: AvailableLocals) {
    current.value = locale
    setThemeCookie('language', locale)
    const i18n = getI18n()
    i18n.global.locale.value = locale
    setI18nLanguage(locale)
    await loadLocaleMessages(locale)
  }

  return { updateLocale, current }
}
